export default "__VITE_ASSET__6RRR0EU7__ 480w, __VITE_ASSET__ClazV4CY__ 720w, __VITE_ASSET__sgk7Ywg0__ 960w, __VITE_ASSET__BzO7MWs8__ 1280w";